<template>
  <div>
    <SiteNav/>
    <b-loading :is-full-page="true" v-model="appLoading" :can-cancel="true"/>
    <section class="section" id="mainApp">
      <div class="columns" v-show="!$root.iframed">
        <div class="column is-one-third">
          <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <a href="/ui/advisor/home/">
                  <b-icon
                    pack="fas"
                    icon="home"
                    class="is-primary"
                  />
                  Dashboard
                </a>
              </li>
              <li class="is-active">
                <a href="#" aria-current="page">Company Screener</a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="column is-one-third">
          &nbsp;<!-- used to be something here -->
        </div>
        <div class="column is-one-third">
        </div>
      </div>
      <div class="app-container">

        <div class="main-body" v-show="!$root.iframed">
          <ScreensList
            v-if="screens"
            v-bind:screens="screens"
            v-bind:companies="companies"
            mode="screening"
            ref="screensList"
          >
            Filter Screens
          </ScreensList>

          <ScreenDetailPane
            v-bind:companies="companies"
          />
        </div>

        <div class="right-bar">
          <Results
            v-bind:screens="screens"
            v-bind:companies="companies"
            v-bind:universe="universe"
            v-bind:portfolio="portfolio"
          />
          <CompanyDetailPane
            ref="detailPane"
            v-bind:screens="screens"
            v-bind:companies="companies"
            v-show="!$root.iframed"
          />
        </div>
      </div>

    </section>
  </div>
</template>

<script>
  import CompanyDetailPane from '@frontend/builder/js/components/CompanyDetailPane.vue';
  import Results from '@frontend/builder/js/components/Results.vue';
  import ScreensList from '@frontend/builder/js/components/ScreensList.vue';
  import ScreenDetailPane from '@frontend/builder/js/components/ScreenDetailPane.vue';
  import EditUniverseButton from '@frontend/builder/js/components/EditUniverseButton.vue';

  import SiteNav from '@frontend/ui/features/nav/SiteNav.vue';
  import Advisor from '@frontend/dash3/js/shared/Advisor.js';
  import eventBus from '@frontend/shared/EventBus.js';
  import gql from 'graphql-tag'
  import telemetry from '@frontend/api/Telemetry';



  export default {
    data() {
      return {
        csrfToken: null,
        screens: {a:[],byId:{},loaded:false},
        companies: {a:[],byId:{},loaded:false},
        screenSets: {a:[],byId:{},loaded:false},
        universe: {
          type: 'fund', // Fund or ModelPortfolio
          key: 'SPYM', // Ticker or Portfolio ID
          name: 'S&P 500',
        },
        portfolio: {},
        offset:0,
        pageIncrement:50,
        iframed: false,
        appLoadingOverride: false
      }
    },
    watch: {
      universe: function(oldUniverse,newUniverse) {
        if(oldUniverse.key != newUniverse.key) {
          this.offset = 0
          this.companies = {loaded: false, a:[], byId:{}}
        }
      }
    },
    apollo: {
      metrics: {
        query: gql`{
            metricDescription {
              edges {
                node {
                  pk
                  name
                  description
                  longDescription
                  updateFrequency
                  benchmarkDescription
                  isInclusionary
                  isBinary
                  sourceLink {
                    url
                  }
                  sourceName
                  subcategory {
                    name
                    image
                    esgissue {
                      slug
                      icon
                      name
                    }
                    pk
                  }
                }
              }
            }
        }`,
        update(data) { 
          let edges = data.metricDescription.edges;
          let a = edges.map((edge)=> {
            let oldNode = edge.node;
            let newNode = {}
            Object.keys(oldNode).forEach((key) => {
              newNode[key.replace(/[A-Z]/g,letter => `_${letter.toLowerCase()}`)] = oldNode[key]
            })
            return(newNode);
          })
          let byId = {}
          a.forEach((metric)=> {
            metric.id = metric.pk
            metric.active = false;
            metric.visible = true;
            metric.userPercentile = 0;
            metric.switchState = false;
            metric.manuallySet = false;
            byId[metric.pk] = metric
          })
          let screens = {a,byId,loaded:(a.length>0)}
          this.linkCompanies(this.companies, screens)
          this.screens = screens
          telemetry.track('Company Screener Loaded', {count: a.length})
        }
      },
      fundHoldings: {
        query() {
          if(this.$root.advisor.hasFeature('Company Screener Bonds')) {
            return(gql`
              query Holdings($fundTicker: [String]!, $portfolioId: Int!, $queryFund: Boolean!, $queryPortfolio: Boolean!, $first: Int, $offset: Int, $bondHoldings: Boolean!, $queryDirect: Boolean!) {
                holdings(seriessnapshot_ShareClass_Ticker_In:$fundTicker, identifier_AssetType_In:[A_0], first:$first, offset:$offset) @include(if: $queryFund) {
                  edges {
                    node {
                      company {
                        pk
                        name
                        marketCap
                        sector
                        metrics {
                          edges {
                            name
                            metricDescriptionId
                            percentile
                          }
                        }
                        primaryIdentifier {
                          symbol
                          orionProductId
                          isin
                          sector
                        }
                      }  
                    } 
                  }
                  pageInfo {
                    hasNextPage
                  }
                  totalCount
                }
                modelPortfolios(pk:$portfolioId) @include(if: $queryPortfolio) {
                  equityHoldings(offset:$offset, first:$first) {
                    totalCount
                    hasMore
                    edges {
                      dollars
                      company {
                        pk
                        name
                        marketCap
                        sector
                        metrics {
                          edges {
                            name
                            metricDescriptionId
                            percentile
                          }
                        }
                        primaryIdentifier {
                          symbol
                          orionProductId
                          isin
                          sector
                        }
                      }
                    }
                  }
                  bondHoldings @include(if: $bondHoldings) {
                    dollars
                    symbol
                  }
                }
                modelPortfolios(pk:$portfolioId) @include(if: $queryDirect) {
                  shareownershipSet(ticker_AssetType_In:["0","1"], offset:$offset, first:$first) {
                    totalCount
                    pageInfo {
                      hasNextPage
                    }
                    edges {
                      node {
                        dollars
                        ticker {
                          company {
                            pk
                            name
                            marketCap
                            sector
                            metrics {
                              edges {
                                name
                                metricDescriptionId
                                percentile
                              }
                            }
                            primaryIdentifier {
                              symbol
                              orionProductId
                              isin
                              sector
                            }

                          }
                          symbol
                          orionProductId
                          isin
                          sector
                        }
                      }
                    }
                  }
                }
              }
            `)
          } else {
            return (gql`
              query Holdings($fundTicker: [String]!, $portfolioId: Int!, $queryFund: Boolean!, $queryPortfolio: Boolean!, $first: Int, $offset: Int, $bondHoldings: Boolean!, $queryDirect: Boolean!) {
                holdings(seriessnapshot_ShareClass_Ticker_In:$fundTicker, identifier_AssetType_In:[A_0], first:$first, offset:$offset) @include(if: $queryFund) {
                  edges {
                    node {
                      company {
                        pk
                        name
                        marketCap
                        sector
                        metrics {
                          edges {
                            name
                            metricDescriptionId
                            percentile
                          }
                        }
                        primaryIdentifier {
                          symbol
                          orionProductId
                          isin
                          sector
                        }
                      }  
                    } 
                  }
                  pageInfo {
                    hasNextPage
                  }
                  totalCount
                }
                modelPortfolios(pk:$portfolioId) @include(if: $queryPortfolio) {
                  equityHoldings(offset:$offset, first:$first) {
                    totalCount
                    hasMore
                    edges {
                      dollars
                      company {
                        pk
                        name
                        marketCap
                        sector
                        metrics {
                          edges {
                            name
                            metricDescriptionId
                            percentile
                          }
                        }
                        primaryIdentifier {
                          symbol
                          orionProductId
                          isin
                          sector
                        }
                      }
                    }
                  }
                  bondHoldings @include(if: $bondHoldings) {
                    dollars
                    symbol
                  }
                }
                modelPortfolios(pk:$portfolioId) @include(if: $queryDirect) {
                  shareownershipSet(ticker_AssetType_In:["0"], offset:$offset, first:$first) {
                    totalCount
                    pageInfo {
                      hasNextPage
                    }
                    edges {
                      node {
                        dollars
                        ticker {
                          company {
                            pk
                            name
                            marketCap
                            sector
                            metrics {
                              edges {
                                name
                                metricDescriptionId
                                percentile
                              }
                            }
                            primaryIdentifier {
                              symbol
                              orionProductId
                              isin
                              sector
                            }

                          }
                          symbol
                          orionProductId
                          isin
                          sector
                        }
                      }
                    }
                  }
                }
              }
            `)
          }
        },
        fetchPolicy: "no-cache",
        errorPolicy: 'ignore',
        variables() {
          if(this.universe.type == 'fund') {
            return {fundTicker:this.universe.key.split(','),
                    queryFund:true,
                    queryPortfolio:false,
                    bondHoldings:false,
                    queryDirect:false,
                    portfolioId:0, first:this.pageIncrement, offset:this.offset}
            } else if(this.universe.type == 'model_portfolio') {
              return {fundTicker:"",
                    queryFund:false,
                    queryDirect:false,
                    queryPortfolio:true,
                    portfolioId:this.universe.key,
                    bondHoldings:(this.offset==0),
                    first:this.pageIncrement, offset:this.offset}
            } else if(this.universe.type == 'model_portfolio_direct') {
              return {fundTicker:"",
                    queryFund:false,
                    queryDirect:true,
                    queryPortfolio:false,
                    portfolioId:this.universe.key,
                    bondHoldings:(this.offset==0),
                    first:this.pageIncrement, offset:this.offset}
            }

        },
        update(data) {
          let companiesA;
          let hasMore = false;
          let totalCount = 1;
          if(data) {
            let portfolio = {}
            if(this.offset > 0) {
              portfolio = this.portfolio
            }

            if(this.universe.type == 'fund') {
              companiesA = data.holdings.edges.map((edge)=> {
                return(edge.node.company)
              });
              hasMore = data.holdings.pageInfo.hasNextPage;
              totalCount = data.holdings.totalCount;
            }
            else if(this.universe.type == 'model_portfolio') {
              companiesA = data.modelPortfolios[0].equityHoldings.edges.filter((edge) => {
                return edge.company && edge.company.primaryIdentifier
              }).map((edge) => {
                if(!(edge.company.primaryIdentifier.symbol in portfolio)) {
                  portfolio[edge.company.primaryIdentifier.symbol] = 0
                }
                portfolio[edge.company.primaryIdentifier.symbol] += edge.dollars
                return(edge.company)
              })
              if (data.modelPortfolios[0].bondHoldings) {
                data.modelPortfolios[0].bondHoldings.map((bondHolding) => {
                  portfolio[bondHolding.symbol] = bondHolding.dollars
                })
              }
              hasMore = data.modelPortfolios[0].equityHoldings.hasMore 
              totalCount = data.modelPortfolios[0].equityHoldings.totalCount;
            }
            else if(this.universe.type == 'model_portfolio_direct') {
              let companiesById = {};
              data.modelPortfolios[0].shareownershipSet.edges.forEach((edge) => {
                if(!(edge.node.ticker.symbol in portfolio)) {
                  portfolio[edge.node.ticker.symbol] = 0
                }
                portfolio[edge.node.ticker.symbol] += edge.node.dollars
                if(! (edge.node.ticker.company.pk in companiesById)) {
                  companiesById[edge.node.ticker.company.pk] = edge.node.ticker.company 
                  companiesById[edge.node.ticker.company.pk].tickers = []
                }
                if(!companiesById[edge.node.ticker.company.pk].tickers.some(function(ticker) { return ticker.symbol == edge.node.ticker.symbol})) {
                  companiesById[edge.node.ticker.company.pk].tickers.push({'symbol':edge.node.ticker.symbol,'orionProductId':edge.node.ticker.orionProductId, 'isin':edge.node.ticker.isin, 'sector':edge.node.ticker.sector})
                }
                if(this.companies.byId[edge.node.ticker.company.pk]) {
                  if(!this.companies.byId[edge.node.ticker.company.pk].tickers.some(function(ticker) { return ticker.symbol == edge.node.ticker.symbol})) {
                    this.companies.byId[edge.node.ticker.company.pk].tickers.push({'symbol':edge.node.ticker.symbol,'orionProductId':edge.node.ticker.orionProductId, 'isin':edge.node.ticker.isin, 'sector':edge.node.ticker.sector})
                  }
                }
                if(!companiesById[edge.node.ticker.company.pk].tickers.some(function(ticker) { return ticker.symbol == edge.node.ticker.symbol})) {
                  companiesById[edge.node.ticker.company.pk].tickers.push({'symbol':edge.node.ticker.symbol,'orionProductId':edge.node.ticker.orionProductId, 'isin':edge.node.ticker.isin, 'sector':edge.node.ticker.sector})
                }
              })
              companiesA = Object.values(companiesById)
              hasMore = data.modelPortfolios[0].shareownershipSet.pageInfo.hasNextPage
              totalCount = data.modelPortfolios[0].shareownershipSet.totalCount
            }
            this.portfolio = portfolio
          }

          let a = [];
          let addedIds = new Set()
          a = companiesA.filter((company) => {return(company!=undefined && 'pk' in company)}).filter((company) => { 
            let  good =  (this.offset ==0 || (!(company.pk in this.companies.byId))) 
                            && (!addedIds.has(company.pk));
            addedIds.add(company.pk)
            return(good)
                          }).map((company) => {
            if (company.metrics && 'edges' in company.metrics) {
              let metricsA = company.metrics.edges.map((item) => {
                let newNode = {}
                Object.keys(item).forEach((key) => {
                  newNode[key.replace(/[A-Z]/g,letter => `_${letter.toLowerCase()}`)] = item[key]
                })

                let result = {'screen':null,...newNode}
                return(result);
              })
              delete(company.metrics)
              let metricById = {}
              metricsA.forEach((m) => {
                metricById[m.metric_description_id] = m
              })
              company.metrics = {'a':metricsA,'byId':metricById}
            }
            else {
              company.metrics = {'a':[],'byId':{}}
            }
            return(company)
          })
        
        
          let byId = {}
          a.forEach((company) => {
            byId[company.pk] = company;
          })
          
          
          let companies = {a, byId, loaded:!hasMore,total:totalCount}
          if(this.offset > 0) {
            companies.byId = {...companies.byId,...this.companies.byId}
            companies.a = [...companies.a,...this.companies.a]
          }
          this.linkCompanies(companies,this.screens)
          this.companies = companies;
          if(hasMore){
            this.offset += this.pageIncrement;
          }
          else {
            this.$root.$emit('universe-loaded')
            telemetry.track('Company Screener Loaded', {universe:this.universe.name, type:this.universe.type, count:companies.a.length})
          }
        }
      
      },
      screen_sets: {
        query: gql`
          query ScreenSets {
            metricScreenSets {
              edges {
                node {
                  pk
                  name
                }
              }
            }
          }`,
          update(data) {
            let screensA = data.metricScreenSets.edges;

            let a = []
            let byId = {}
            a = screensA.map((edge)=> {
              let n = edge.node;
              n.id = n.pk;
              return n;
            });
            a.forEach((screen) => {
              byId[screen.pk] = screen
            })  
            this.screenSets =  {a,byId,loaded:(a.length > 0)}
          }
      },
    },
    methods: {
      linkCompanies(companies, metrics) {
        companies.a.forEach((company)=> {
          company.metrics.a.forEach( (metric) => {
            if(metric.metric_description_id in metrics.byId) { 
              metric.screen = metrics.byId[metric.metric_description_id]
            }
         })
        })
      }
    },
    beforeCreate() {
      this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;
      this.$root.advisor = new Advisor();

    },
    created() {

        this.$root.$on('universe-changed', (type, key, name) => {
          this.universe = {type, key, name}          
        });

    },
    computed: {
      appLoading: {
        get() {
          return((!this.appLoadingOverride) && !(this.screens.loaded && this.companies.loaded && this.screenSets.loaded));
        }, 
        set(v) {
          this.appLoadingOverride = true
        }
      }
    },
    components: {
      CompanyDetailPane,
      Results,
      ScreensList,
      ScreenDetailPane,
      EditUniverseButton,
      SiteNav,
    }
  }

   
</script>

<style lang="scss" scoped>
  #mainApp {
    min-height: 100vh;
  }

  .mymargin {
    margin: auto;
  }

  .app-container {
    display: flex;

    .main-body {
      flex: 5;
      padding: 1rem;
    }
    .right-bar {
      flex: 3;
    }
  }
</style>
